module.exports = __webpack_public_path__ + "src/assets/games/42/107.jpg";